import React, { Component } from "react";
import { Link } from "react-router-dom";

import styles from "./NewsletterHeader.css";

class NewsletterHeader extends Component {
  render() {
    const { newsletter } = this.props;
    if (!newsletter || !newsletter.authors || newsletter.authors.length === 0) return null;
    return (
      <div className={styles.root}>
        <span className={styles.heading}>{"By "}</span>
        {newsletter.authors.map((author, index) =>
          <Link key={author.username} to={`/authors/${author.username}`} className={styles.author}>
            {author.display_name}{index < newsletter.authors.length - 1 && ", "}
          </Link>)}
      </div>
    );
  }
}

export default NewsletterHeader;
